import actions from './actions';

const {
  GET_MENU_BEGIN,
  GET_MENU_SUCCESS,
  GET_MENU_ERROR,
  GET_ROLE_BEGIN,
  GET_ROLE_SUCCESS,
  GET_ROLE_ERROR,
  GET_USER_BEGIN,
  GET_USER_SUCCESS,
  GET_USER_ERROR,
  CLEAR_ERROR,
} = actions;

const SET_SELECTED_FIRMA = 'SET_SELECTED_FIRMA';

export const setSelectedFirmaEvrimId = (firmaId) => ({
  type: SET_SELECTED_FIRMA,
  payload: firmaId,
});

const initState = {
  menu: [],
  role: [],
  user: [],
  selectedFirmaEvrimId: null,
  loading: false,
  error: false,
  
};

const userReducer = (state = initState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case GET_MENU_BEGIN:
    case GET_USER_BEGIN:
    case GET_ROLE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_MENU_SUCCESS:
      return {
        ...state,
        loading: false,
        menu: data,
      };
    case GET_ROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        role: data,
      };
    case GET_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        user: data,
      };
    case SET_SELECTED_FIRMA:
      return {
        ...state,
        selectedFirmaEvrimId: action.payload,
      };
    case GET_MENU_ERROR:
    case GET_USER_ERROR:
    case GET_ROLE_ERROR:
      return {
        ...state,
        loading: false,
        error: err,
      };
    case CLEAR_ERROR:
      return {
        ...state,
        loading: false,
        error: false,
      };
    default:
      return state;
  }
};

export { userReducer };
